import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavBar, BreadCumb, TimeOut, Pagination } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';
import '../../css/responsive.css';
import '../../css/tablesPOS.css';

const apiClient = ApiClient.getInstance();
//Header 
const headersDataTable = [
    { title: "Nombre", value: true },
    { title: "Código", value: true },
    { title: "Stock", value: true },
];

class InventoryView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            total: 0,
            ListItemsGroup: [],
            inventoryData: [],
            inventoryDataTotalRows: 0,
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            groupNum: '',
            ItmsGroups: []

        }
    }

    componentDidMount = async () => {
        this.GetInventoryData();
        this.GetItmsGroups();
    }

    //Buscar inventarios
    searchItems = async filter => {
        await this.callDocumentsListService(filter);
    };

    //Listar Documentos por Filtros
    callDocumentsListService = async (filter = { priceValue: '---', groupCodeValue: '---' }) => {
        const { enableSpinner } = this.props;
        enableSpinner(true);
        let inventoryDataResponse = await apiClient.getItemsrList(filter);
        enableSpinner(false);
        if (inventoryDataResponse.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                data: inventoryDataResponse.data.partners,
                total: inventoryDataResponse.data.totalRows
            });
        }
    };

    //#region ########## INVENTORY DATA ##################################################
    GetInventoryData = async (page = 1) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user, groupNum } = this.state

        const data = {
            page,
            groupNum: groupNum,
            boPriceList: _user.U_FMB_PLPrintTags
        }

        enableSpinner(true);
        const getInventoryDataResponse = await apiClient.getInventoryData(data);
        enableSpinner(false);

        if (!getInventoryDataResponse.status) {
            showAlert({ type: "error", message: getInventoryDataResponse.message });
            return;
        }

        if (getInventoryDataResponse.data.Items.length === 0) {
            showAlert({ type: "info", message: "No hay Información por mostrar" });
            return;
        }

        await this.setState({
            inventoryData: getInventoryDataResponse.data.Items,
            inventoryDataTotalRows: getInventoryDataResponse.data.TotalRows
        });



    }
    //#endregion

    DoSearch = async (data, searchTerm) => {
        const tableReg = document.getElementById(data);
        const searchText = document.getElementById(searchTerm).value.toLowerCase();
        let total = 0;
        // Recorremos todas las filas con contenido de la tabla
        for (let i = 1; i < tableReg.rows.length; i++) {
            // Si el td tiene la clase "noSearch" no se busca en su contenido
            if (tableReg.rows[i].classList.contains("noSearch")) {
                continue;
            }
            let found = false;
            const cellsOfRow = tableReg.rows[i].getElementsByTagName('td');
            // Recorremos todas las celdas
            for (let j = 0; j < cellsOfRow.length && !found; j++) {
                const compareWith = cellsOfRow[j].innerHTML.toLowerCase();
                // Buscamos el texto en el contenido de la celda
                if (searchText.length === 0 || compareWith.indexOf(searchText) > -1) {
                    found = true;
                    total++;
                }
            }
            if (found) {
                tableReg.rows[i].style.display = '';
            } else {
                // si no ha encontrado ninguna coincidencia, esconde la
                // fila de la tabla
                tableReg.rows[i].style.display = 'none';
            }
        }
        // mostramos las coincidencias
        const lastTR = tableReg.rows[tableReg.rows.length - 1];
        const td = lastTR.querySelector("td");
        lastTR.classList.remove("hide", "red");
        if (searchText === "") {
            lastTR.classList.add("hide");
        } else if (total) {
            td.innerHTML = "Se ha encontrado " + total + " coincidencia" + ((total > 1) ? "s" : "");
        } else {
            lastTR.classList.add("red");
            td.innerHTML = "No se han encontrado coincidencias";
        }
    }


    GetItmsGroups = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const GroupsItemData = await apiClient.getGroupsItemData();
        if (GroupsItemData.status !== 1) {
            showAlert({ type: 'warning', message: GroupsItemData.message });
            return;
        }
        this.ChangeAnyPropInState('ItmsGroups', GroupsItemData.data?.GrupoArticulo)
    }

    ChangeAnyPropInState = (key, value) => {
        this.setState({
            [key]: value
        })
    }

    ChangeItemGrpNum = async (value) => {
        await this.setState({
            groupNum: value,
            itemCode: ''
        })
        this.GetInventoryData();
    }


    render() {
        const { inventoryData, inventoryDataTotalRows, _user, groupNum, ItmsGroups } = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} logoCounter={true} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'INVENTARIO'} url1={'#'} />
                <div style={{ marginLeft: "4rem" }}>
                    <div className="">
                        <div className="row m-3 row-responsive">
                            <h3 className="modal-title ml-3 mb-2 mt-3" id="inventoryModalLabel">Inventario</h3>
                        </div>
                        <div className="row row-responsive" style={{ marginLeft: "1rem" }}>
                            <div className="col-12 col-md-4 mb-1">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="basic-addon1"><strong>Grupo: </strong></span>
                                    </div>
                                    <select
                                        id="toggleCostumer"
                                        className="form-control"
                                        onChange={(event) => this.ChangeItemGrpNum(event.target.value)}
                                        value={groupNum}
                                    >
                                        <option value={''}>Seleccione una opción: </option>
                                        {
                                            ItmsGroups.map((option, index) => {
                                                return (
                                                    <option key={index + option} value={option.ItmsGrpCod}> {option.ItmsGrpNam ?? ''}</option>
                                                );
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 mb-1">
                                <input
                                    type="text"
                                    className="form-control "
                                    placeholder="Buscar en tabla"
                                    id="itemISearch"
                                    onKeyUp={() => this.DoSearch("itemsData", "itemISearch")} />
                            </div>
                            <div className="col-12 col-md-4 mb-1">

                            </div>

                        </div>
                        <div className="mt-3 card" style={{ maxHeight: "500px" }}>

                            <div className='scrollTable' >
                                <table className="table table-striped table-hover" id="itemsData" style={{ border: " 1px solid rgba(0, 0, 0, 0.125)", borderRadius: "0.25rem" }}>
                                    <thead className='sticky-header' style={{ background: 'white' }}>
                                        <tr>
                                            <th>Código</th>
                                            <th>Descripción</th>
                                            <th>P. Venta</th>
                                            <th>P. Promedio</th>
                                            <th>Almacén</th>
                                            <th>Existencia</th>
                                            <th>CodeBar</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {!!inventoryData && inventoryData.map((item, index) => {
                                            return (
                                                <tr key={`inventory${item.ItemCode + index}`}>
                                                    <td><strong>{item.ItemCode}</strong></td>
                                                    <td>{item.ItemName}</td>
                                                    <td className="noSearch">{Number(item.Price) ?? ""}</td>
                                                    <td className="noSearch">{Number(item.AvgPrice) ?? ""}</td>
                                                    <td className="noSearch">{item.WhsCode}</td>
                                                    <td className="noSearch">{Number(item.OnHand).toFixed(4) || ""}</td>
                                                    <td className="noSearch">{item.CodeBars ?? ''}</td>
                                                </tr>
                                            )
                                        })}
                                        <tr className='noSearch hide'>
                                            <td colSpan="8"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="">
                            {/* <ul className="pagination m-2 justify-content-end">
                                <li className="page-item">
                                    <a className="page-link" href="#" aria-label="Previous">
                                        <span aria-hidden="true">&laquo;</span>
                                    </a>
                                </li>
                                <li className="page-item"><a className="page-link" href="#">1</a></li>
                                <li className="page-item"><a className="page-link" href="#">2</a></li>
                                <li className="page-item"><a className="page-link" href="#">3</a></li>
                                <li className="page-item">
                                    <a className="page-link" href="#" aria-label="Next">
                                        <span aria-hidden="true">&raquo;</span>
                                    </a>
                                </li>
                            </ul> */}
                            {inventoryDataTotalRows > 3 &&
                                <Pagination
                                    refresh={this.GetInventoryData}
                                    totalRowsRefresh={inventoryDataTotalRows} />
                            }
                        </div>






                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InventoryView);
